import { useTranslation } from "react-i18next";
import { AttemptPracticeDonutSvg } from "../../../Practice/components/AttemptPracticeDonutSvg";
import styles from "./ReviseAttemptAnalysis.module.scss";

export type ReviseAttemptAnalysisProps = {
  correct: number;
  incorrect: number;
  notAnswered: number;
  variant: "wide" | "narrow";
  isMobileLayout: boolean;
};

export function ReviseAttemptAnalysis({
  correct,
  incorrect,
  notAnswered,
  variant,
  isMobileLayout,
}: ReviseAttemptAnalysisProps) {
  const { t } = useTranslation("selflearn");
  /** 54_IL_Web / 55_IL_Tab / 51_IL_Mobile (Figma attempt-analysis card) */
  const isDesktop = variant === "wide";
  const isTablet = variant === "narrow" && !isMobileLayout;

  const cardClass = `${styles.card} ${
    isDesktop
      ? styles.cardDesktop
      : isTablet
        ? styles.cardTablet
        : styles.cardPhone
  }`;
  const titleClass = `${styles.title} ${
    isDesktop
      ? styles.titleDesktop
      : isTablet
        ? styles.titleTablet
        : styles.titlePhone
  }`;
  const legendLabelClass = `${styles.legendLabel} ${
    isDesktop
      ? styles.legendLabelDesktop
      : isTablet
        ? styles.legendLabelTablet
        : styles.legendLabelPhone
  }`;
  const legendValueClass = `${styles.legendValue} ${
    isDesktop
      ? styles.legendValueDesktop
      : isTablet
        ? styles.legendValueTablet
        : styles.legendValuePhone
  }`;

  return (
    <div className={cardClass}>
      <h2 className={titleClass}>{t("exerciseReport.attemptAnalysis")}</h2>

      <div className={styles.body}>
        <div className={styles.donutWrap}>
          <AttemptPracticeDonutSvg
            correct={correct}
            incorrect={incorrect}
            notAnswered={notAnswered}
            size={80}
            strokeWidth={14}
          />
        </div>

        <div className={styles.legend} role="list">
          <div className={styles.legendRow} role="listitem">
            <span
              className={`${styles.dot} ${styles.dotCorrect}`}
              aria-hidden
            />
            <span className={legendLabelClass}>
              {t("exerciseReport.correct")}
            </span>
            <span className={legendValueClass}>{correct} Q&apos;s</span>
          </div>

          <div className={styles.legendRow} role="listitem">
            <span
              className={`${styles.dot} ${styles.dotIncorrect}`}
              aria-hidden
            />
            <span className={legendLabelClass}>
              {t("exerciseReport.incorrect")}
            </span>
            <span className={legendValueClass}>{incorrect} Q&apos;s</span>
          </div>

          <div className={styles.legendRow} role="listitem">
            <span
              className={`${styles.dot} ${styles.dotNotAnswered}`}
              aria-hidden
            />
            <span className={legendLabelClass}>
              {t("exerciseReport.notAnswered")}
            </span>
            <span className={legendValueClass}>{notAnswered} Q&apos;s</span>
          </div>
        </div>
      </div>
    </div>
  );
}
